import { Instagram, NumbersHelper, SocialNetworksAvailables, TikTok, Tip, Twitter, Youtube } from '@hub/shared'
import { useCallback, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import './profile-metrics.component.scoped.scss'
import { SqTip } from '@squidit/react-css'

interface Props {
  socialNetworkObject: Instagram | Twitter | Youtube | TikTok
  socialNetwork: SocialNetworksAvailables
}

export default ({ socialNetworkObject, socialNetwork }: Props) => {
  const numbersHelper = useMemo(() => new NumbersHelper(), [])

  const [t, i18n] = useTranslation('cardSocialNetwork')

  const parseMetrics = useCallback(
    (
      socialNetworkObject: Instagram | Youtube | Twitter | TikTok
    ): Array<{ name: string; value: number; tip?: string; leftIcon?: string; percentage?: boolean }> => {
      const metrics = [
        {
          name: 'followers',
          value: socialNetworkObject?.followers || 0,
        },
      ]

      if (socialNetwork === 'youtube') {
        metrics[0].name = 'subscribers'
      }
      return metrics
    },
    [socialNetwork]
  )

  return (
    <ul className="metrics">
      {parseMetrics(socialNetworkObject)?.map(({ name, value, leftIcon, tip, percentage }) => (
        <li key={name}>
          <span>
            {percentage
              ? `${(value * 100).toLocaleString(i18n.language, { maximumFractionDigits: 2, minimumFractionDigits: 1 })}%`
              : numbersHelper.thousandTransform(value)}
            {tip ? <SqTip message={tip} className="ml-1" fontSize="0.9rem" /> : null}
          </span>
          <label>
            {leftIcon ? leftIcon : null} {t(`metrics.${name}`)}
          </label>
        </li>
      ))}
    </ul>
  )
}
